exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expiration-warning[data-v-35edc8d0],.expiration-warning i[data-v-35edc8d0]{color:#f99b0d}.expiration-warning.canRenovate[data-v-35edc8d0]{cursor:pointer}.td-cell-150[data-v-35edc8d0]{width:150px;max-width:150px;min-width:150px}.td-cell-250[data-v-35edc8d0]{width:250px;max-width:250px;min-width:250px}[data-v-35edc8d0] .table-full .v-datatable.v-table>tbody{max-height:calc(105vh - 426px);min-height:calc(105vh - 426px)}", ""]);

// exports
